@if (ProposalRequestVendorFormArray && LocalizationInfo) {
  <div class="container-fluid p-0">
    @for (
      ProposalRequestVendorFormGroup of ProposalRequestVendorFormArray.controls;
      track ProposalRequestVendorFormGroup
    ) {
      <form class="row mb-3" [formGroup]="ProposalRequestVendorFormGroup">
        <div class="col">
          <app-display-card [innerPanel]="true">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <label
                    class="form-label"
                    requiredAsterisk
                    for="prv-legalName"
                  >
                    Legal name
                  </label>
                  <input
                    id="prv-legalName"
                    type="text"
                    class="form-control"
                    formControlName="legalName"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <label class="form-label" for="prv-dba">DBA</label>
                  <input
                    id="prv-dba"
                    type="text"
                    class="form-control"
                    formControlName="dba"
                  />
                </div>
              </div>
            </div>

            <form
              class="row g-3 mt-1"
              [formGroup]="ProposalRequestVendorFormGroup.controls['Address']"
            >
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <label class="form-label" requiredAsterisk for="prv-address1">
                    Address 1
                  </label>
                  <input
                    id="prv-address1"
                    type="text"
                    class="form-control"
                    formControlName="address1"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <label class="form-label" for="prv-address2">
                    Address 2
                  </label>
                  <input
                    id="prv-address2"
                    type="text"
                    class="form-control"
                    formControlName="address2"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-0">
                  <label class="form-label" requiredAsterisk for="prv-city">
                    City
                  </label>
                  <input
                    id="prv-city"
                    type="text"
                    class="form-control"
                    formControlName="city"
                  />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-0">
                  <label class="form-label" requiredAsterisk for="prv-state">
                    {{ LocalizationInfo.territory.label }}
                  </label>
                  <select
                    id="prv-state"
                    class="form-select"
                    formControlName="state"
                  >
                    @for (
                      SubNationalDivision of SubNationalDivisions;
                      track SubNationalDivision
                    ) {
                      <option [ngValue]="SubNationalDivision.abbreviation">
                        {{ SubNationalDivision.name }}
                      </option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-0">
                  <label class="form-label" requiredAsterisk for="prv-zip">
                    {{ LocalizationInfo.postalCode.label }}
                  </label>
                  <input
                    id="prv-zip"
                    type="text"
                    class="form-control"
                    formControlName="zip"
                    placeholder="{{ LocalizationInfo.postalCode.format }}"
                    [inputMask]="country === 'US' ? usZipMask : canadianZipMask"
                  />
                </div>
              </div>
            </form>

            <hr class="my-3 prv-divider" />

            <div class="row g-3">
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <label
                    class="form-label"
                    requiredAsterisk
                    for="prv-firstName"
                  >
                    First name
                  </label>
                  <input
                    id="prv-firstName"
                    type="text"
                    class="form-control"
                    formControlName="firstName"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-0">
                  <label class="form-label" requiredAsterisk for="prv-lastName">
                    Last name
                  </label>
                  <input
                    id="prv-lastName"
                    type="text"
                    class="form-control"
                    formControlName="lastName"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="form-label" requiredAsterisk for="prv-phone">
                    Phone
                  </label>
                  <input
                    id="prv-phone"
                    type="text"
                    class="form-control"
                    formControlName="phone"
                    placeholder="(___) ___-____"
                    [inputMask]="phoneMask"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group mb-0">
                  <label class="form-label" for="prv-ext">Ext.</label>
                  <input
                    id="prv-ext"
                    type="text"
                    class="form-control"
                    formControlName="phone2Ext"
                    [inputMask]="phoneExtensionMask"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="form-label" for="prv-workPhone">
                    Work phone
                  </label>
                  <input
                    id="prv-workPhone"
                    type="text"
                    class="form-control"
                    formControlName="phone2"
                    placeholder="(___) ___-____"
                    [inputMask]="phoneMask"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group mb-0">
                  <label class="form-label" requiredAsterisk>Email</label>
                  <p class="prv-email-help">
                    Bids from unregistered vendors should be submitted via
                    email, not through the VIVE platform.
                  </p>
                  <app-email-tagfield
                    [Emails]="
                      ProposalRequestVendorEmailMap.get(
                        ProposalRequestVendorFormGroup
                      ) || []
                    "
                    (addedEmail)="
                      updateEmail(ProposalRequestVendorFormGroup, $event)
                    "
                    (removedEmail)="
                      updateEmail(ProposalRequestVendorFormGroup, $event)
                    "
                  ></app-email-tagfield>
                </div>
              </div>
            </div>
          </app-display-card>
        </div>
      </form>
    }
  </div>
}
